import { decode } from "entities";

/**
 * Decode HTML entities using the `entities` package (safe, no DOM parsing).
 * Kept separate from {@link ./helper} so consumers (e.g. tree export) do not pull the full helper graph.
 */
export function decodeHtmlEntities(value: any): any {
  function htmlEntityDecode(str: string): string {
    try {
      return decode(str);
    } catch (error) {
      console.warn("HTML entity decoding failed:", error);
      return str;
    }
  }

  if (typeof value === "string") {
    return htmlEntityDecode(value);
  }

  if (Array.isArray(value)) {
    return value.map((item) => decodeHtmlEntities(item));
  }

  if (value && typeof value === "object") {
    const decodedObject = Object.fromEntries(
      Object.entries(value).map(([key, val]) => [key, decodeHtmlEntities(val)])
    );
    return Object.keys(decodedObject).length > 0 ? decodedObject : {};
  }

  return value;
}
